export default {
      id: "ignition-off-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#ignition-off",
      toString: function () {
        return this.url;
      }
    }